import React from 'react';
import Banner from '../../common/Banner';
import meetSimfinance from '../../../assets/images/common/meet-simfinance.webp';

const AboutBanner = () => {
  const bannerData = {
    backgroundImage: meetSimfinance,
    title: "Meet SimFinance.",
    description: "We're not just building a tool. We're building trust, confidence, and a more financially literate Ghana.",
    buttonText: "Contact Sales",
    buttonLink: "/contact",
    buttonVariant: "secondary"
  };

  return <Banner {...bannerData} />;
};

export default AboutBanner;